import { useContext, useState } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Prismic from "helpers/Prismic";
import { globalPropsRequests } from "utils/globalProps";
import StickyLinks from "containers/ReadyToShip/StickyLinks";
import GamingProductList from "containers/CategoryLandingSlices/GamingProductList";
import breakPoints, { colors } from "helpers/Styles";
import { Element } from "react-scroll";
import PageHeader from "components/PageHeader";
import Error from "components/Error";
import Loader from "components/Loader";
import Link from "next/link";
import Image from "next/image";
import arrow from "public/icons/icon_arrow.svg";
import { StorefrontContext } from "providers/storefront";
import Script from "next/script";

const gaming = ({ content, featureListDOCS }) => {
  const { isFallback } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  if (!content) {
    return <Error code={404} />;
  }

  const {
    seo_title: seoTitle,
    seo_description: seoDescription,
    title,
    description,
    body,
  } = content;
  const [activeNav, setActiveNav] = useState(0);
  const listTitles = body.map((bodyItem) => bodyItem.primary.product_title);
  const { isAnnouncementBarOpen } = useContext(StorefrontContext);
  const handleActiveNav = (index) => {
    setActiveNav(index);
  };
  return (
    <>
      <Head>
        <link
          rel="preconnect dns-prefetch"
          href="https://triplewhale-pixel.web.app/"
          crossOrigin="true"
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://api.config-security.com/"
          crossOrigin="true"
        />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
      </Head>
      <Script src="tripleWhale.js" dangerouslySetInnerHTML={{ __html: 'TripleHeadless = "aftershockpcsg.myshopify.com"'}} strategy="lazyOnload" />
      <main>
        {content?.banner &&
        Object.keys(content.banner).length !== 0 &&
        content?.mobile_banner &&
        Object.keys(content.mobile_banner).length !== 0 ? (
          <PageHeader
            bannerImage={content.banner}
            bannerImageMobile={content.mobile_banner}
            title={title}
            description={description[0].text}
          />
        ) : null}
        <div className="wrapper">
          <div className="tabContent">
            <div className="sticky_list">
              <ul>
                {listTitles.map((item, listIndex) => (
                  <StickyLinks
                    item={item}
                    listIndex={listIndex}
                    key={item}
                    handleActiveNav={handleActiveNav}
                    activeNav={activeNav}
                  />
                ))}
              </ul>
            </div>
            <div className="gaming_product_list anchor-container">
              {body.map((productSlices, index) => (
                <Element
                  name={listTitles[index]}
                  className={`element `}
                  key={listTitles[index]}
                >
                  <GamingProductList
                    data={productSlices}
                    features={featureListDOCS}
                    index={index}
                    fixedPrice={false}
                    readyToShip={false}
                  />
                </Element>
              ))}
            </div>
          </div>
        </div>

        {/* <div className="bottom_info">
          <p>
            Not sure where to start? Answer a few short questions and we’ll give
            you a custom recommendation based on your needs.
          </p>

          <div className="find-your-setup">
            <Link href="/survey">
              <button type="button" className="button_container">
                <div className="two_column_button"> FIND YOUR SETUP</div>
                <div className="arrow_right">
                  <Image draggable={false} src={arrow} alt="find your setup" />
                </div>
              </button>
            </Link>
          </div>
        </div> */}
      </main>
      <style jsx>
        {`
          .tabContent {
            display: flex;
          }
          .sticky_list {
            flex: 1;
          }
          .sticky_list ul {
            position: sticky;
            top: 100px;
            padding-top: 50px;
            list-style-type: none;
            margin-bottom: 0px;
            padding-bottom: 16px;
            padding-left: 0px;
          }
          .gaming_product_list {
            flex: 3;
            display: flex;
            flex-direction: column;
            margin-left: auto;
          }
          .find-your-setup {
            display: flex;
            justify-content: center;
          }
          .button_container {
            display: flex;
            background: none !important;
            border: none;
          }
          .button_container:hover > .two_column_button {
            background: #800006;
          }
          .button_container:hover > .arrow_right {
            background: #141414;
          }
          .two_column_button {
            height: 48px;
            min-width: 128px;
            color: white;
            background: #950810;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            border-radius: 3px 0 0 3px;
            border: none;
            outline: 0;
            padding: 12px 24px;
            text-transform: uppercase;
          }
          .arrow_right {
            width: 48px;
            height: 48px;
            background: #242424;
            display: flex;
            justify-content: center;
            cursor: pointer;
            border-radius: 0px 3px 03px 0px;
          }
          .arrow_right img {
            width: 25px;
          }
          main {
            background-color: ${colors.n500};
          }
          .anchor-container {
            padding-top: 330px;
            margin-top: -330px;
          }
          @media (max-width: ${breakPoints.medium}) {
            .sticky_list {
              flex: 1;
            }
            .tabContent {
              flex-direction: column;
              justify-content: center;
            }
            .gaming_product_list {
              width: 100%;
            }
            .sticky_list {
              position: sticky;
              top: ${isAnnouncementBarOpen ? '79.5px' : '48px'};
              background-color: black;
              z-index: 3;
            }
            .sticky_list > ul {
              white-space: nowrap;
              overflow-x: scroll;
              padding-top: 0px;
              padding-right: 10px;
              display: flex;
              padding-right: 30px;
            }
          }
          .bottom_info {
            padding: 0px 0 60px 0;
            color: #e4e4e4;
            font-family: 'Roboto-Light';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            width: 30%;
            justify-content: center;
            margin: auto;
          }
          @media (max-width: ${breakPoints.medium}) {
            .bottom_info {
              width: 90%;
              margin: 0 auto;
            }
          }
          @media (max-width: 425px) {
            .sticky_list::after {
              content: '';
              width: 60px;
              background: linear-gradient(
                to left,
                rgba(0, 0, 0, 1),
                rgba(0, 0, 0, 0.2)
              );
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
            }
          }
        `}
      </style>
    </>
  );
};

export async function getStaticProps({ params, preview = false, previewData }) {
  const { handle } = params;
  const { ref } = previewData || {};
  const global = {};

  let menu = null;

  const contentOptions = {
    fetchLinks: ["pc_model.base_price", "pc_model.base_price_compare_at"],
  };
  if (ref) contentOptions.ref = ref;

  const content = await Prismic.getByUID(
    "gaming_landing_page",
    `glp-${handle}`,
    contentOptions
  ).then((res) => res?.data || null);

  if (!content) {
    return { notFound: true };
  }

  globalPropsRequests.push(
    Prismic.getByUID("page_menu", "menu_gaming", ref ? { ref } : null)
      .then((res) => ["menu_gaming", res])
      .catch(() => null)
  );

  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          if (id === "menu_gaming") menu = body.data;
          else global[id] = body.data;
        }
      });
    })
    .catch(() => null);

  let featureListDOCS = [];

  if (content?.body) {
    const featureListIDs = content.body
      .map((productGroups) => productGroups.items)
      .flat()
      .map((item) => item?.features?.id)
      .filter((item, i, ar) => ar.indexOf(item) === i && item);
    //.map((item) => item?.features);

    featureListDOCS = await Prismic.getByIDs(
      featureListIDs,
      ref ? { ref } : null
    ).then((res) => res?.results || []);
  }

  return {
    props: {
      global,
      handle,
      content,
      featureListDOCS,
      menu,
      preview,
    },
    revalidate: 1,
  };
}

export async function getStaticPaths() {
  return {
    paths: [
      { params: { handle: "desktops" } },
      { params: { handle: "laptops" } },
    ],
    fallback: true,
  };
}

export default gaming;
